import { fork } from 'redux-saga/effects'
import AuthSagas from './auth/sagas'
import SupplierSagas from './supplier/sagas'
import UserSagas from './user/sagas'
import BookableSagas from './bookable/sagas'
import TripSagas from './trip/sagas'
import BookingSagas from './booking/sagas'
import ProfileSagas from './profile/sagas'
import PaymentSagas from './payment/sagas'

export default function* rootSaga() {
  yield fork(AuthSagas)
  yield fork(SupplierSagas)
  yield fork(UserSagas)
  yield fork(BookableSagas)
  yield fork(TripSagas)
  yield fork(BookingSagas)
  yield fork(ProfileSagas)
  yield fork(PaymentSagas)
}
